import axios from 'axios';

const calculateRating = (rest) => {
	let point = 0

	if (rest.BerlingskeRating !== 0) {
		point += (rest.BerlingskeRating * 20) - 20
	} else {
		point += 40
	}
	if (rest.PolitikenRating !== 0) {
		point += (rest.PolitikenRating * 20) - 20
	} else {
		point += 40
	}
	
	if (rest.Michelin !== 0) {
		if (rest.Michelin  === '3') {
			point += 100
		} else if (rest.Michelin  === '2') {
			point += 90
		} else if (rest.Michelin  === '1') {
			point += 80
		} else if (rest.Michelin  === 'Bib Gourmand') {
			point += 70
		} else if (rest.Michelin  === 'Michelin Plate') {
			point += 60
		}
	} else {
		point += 40
	}

	if (rest.WhiteGuideRating !== undefined) {
		point += Number(rest.WhiteGuideRating)
	} else{
		point += 40
	}
	return point;
}

export function loadApi() {

	return function(dispatch) {

		axios
		.get(`http://etbord.coa.dk/api/`)
		.then(res => {

			const restaurants = res.data.restaurants;
			const area = [];
			const price = [];
			for (let i in restaurants){
				
				restaurants[i].rating = calculateRating(restaurants[i]);

				if (restaurants[i].area.name && area.indexOf(restaurants[i].area.name) === -1 ){
					area.push(restaurants[i].area.name);
				}
				if (restaurants[i].price && price.indexOf(restaurants[i].price) === -1 ){
					price.push(restaurants[i].price);
				}
			};

			function compare(a,b) {
				if (a.rating < b.rating) return -1;
				if (a.rating > b.rating) return 1;
				return 0;
			  }
			  
			  restaurants.sort(compare).reverse();

			dispatch({type: "DEFAULTS", payload: {
				restaurants: restaurants,
				areas: area,
				prices: price,
			}});

			dispatch({type: "AREA_SELECTED", payload: {
				areasSelected: area,
			}});

			dispatch({type: "PRICE_SELECTED", payload: {
				pricesSelected: price,
			}});

			dispatch( filterResults() );

		})
		.catch(err => {
			console.log(err);
		});
	}	
}

export function filterResults() {
	return function(dispatch, getState) {
		const main = getState().main;
		const areasSelected = main.areasSelected
		const pricesSelected = main.pricesSelected

		const restaurantsSelected = main.restaurants.filter(function(e){
			return (areasSelected.indexOf(e.area.name) > -1 &&
				pricesSelected.indexOf(e.price) > -1 ) ? e : false ;
		})

		dispatch({type: "FILTER_RESULTS", payload: {
			restaurantsSelected,
		}});
	}
}

export function toggleArea(area) {
	return function(dispatch, getState) {
		let areasSelected = getState().main.areasSelected.slice();
		if (areasSelected.indexOf(area) > -1 ) {
			areasSelected.splice(areasSelected.indexOf(area), 1);
		} else {
			areasSelected.push(area);
		}

		dispatch({type: "AREA_SELECTED", payload: {
			areasSelected,
		}});

		dispatch( filterResults() );
	}
};

export function togglePrice(price) {
	return function(dispatch, getState) {

		let pricesSelected = getState().main.pricesSelected.slice();

		if (pricesSelected.indexOf(price) > -1 ) {
			pricesSelected.splice(pricesSelected.indexOf(price), 1);
		} else {
			pricesSelected.push(price);
		}

		dispatch({type: "PRICE_SELECTED", payload: {
			pricesSelected,
		}});
		
		dispatch( filterResults() );
	}
};


// WEBPACK FOOTER //
// ./src/actions.js